import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import styled from "styled-components"
import { Container, Match, Text, Flag } from "./Summary"
import axios from "axios"

const SmallArea = styled(Text)`
    width: 10%;
`
const BigArea = styled.div`
    width: 40%;
    display: flex;
    justify-content: flex-start;
    gap: 16px;
`
const SmallAreaB = styled(SmallArea)`
    font-family: "Poppins Bold";
`

const BigAreaB = styled(BigArea)`
    font-family: "Poppins Bold";
    `

const TextB = styled(Text)`
    font-family: "Poppins Bold";
`

export default function RoundRobin() {
    const [data, setData] = useState([]);
    const { id } = useParams()
    useEffect(() => {
        async function getData() {
            try {
                console.log("id", id)
                console.log(id);
                let res = await axios.get(process.env.REACT_APP_TOURNAMENT_ROUND_ROBIN_TABLE_ENDPOINT + id);
                setData(res.data);
                console.log("robin");
                console.log(res);
            } catch (x) {
                console.log(x)
            }
        }
        getData();
    }, [id])
    return (
        <Container>
            <Match odd={1}>
                <SmallAreaB>#</SmallAreaB>
                <BigAreaB>
                    <TextB>Teams</TextB>
                </BigAreaB>
                <SmallAreaB>MP</SmallAreaB>
                <SmallAreaB>W</SmallAreaB>
                <SmallAreaB>L</SmallAreaB>
                <SmallAreaB>D</SmallAreaB>
                <SmallAreaB>Pts</SmallAreaB>
            </Match>
            {
                data.map((team, index) => {
                    return (
                        <Match key={index} odd={index % 2}>
                            <SmallArea>{index + 1}.</SmallArea>
                            <BigArea>
                                <Flag src={team.flag} />
                                <Text>{team.name}</Text>
                            </BigArea>
                            <SmallArea>{team.matchPlayed}</SmallArea>
                            <SmallArea>{team.won}</SmallArea>
                            <SmallArea>{team.loss}</SmallArea>
                            <SmallArea>{team.draw}</SmallArea>
                            <SmallArea>{team.pts}</SmallArea>
                        </Match>
                    )
                })
            }
        </Container>
    )
}